<template>
  <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"></div>
  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-center justify-center p-4">
      <div class="relative transform overflow-hidden rounded-lg bg-gray-800 text-white shadow-xl transition-all sm:max-w-3xl w-full">
        <div class="p-6">
          <div class="flex justify-between items-center mb-6">
            <h3 class="text-xl font-semibold text-indigo-300">แก้ไขซอมบี้</h3>
            <button @click="cancelModal" class="text-gray-400 hover:text-white">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <form @submit.prevent="updateZombie">
            <div class="space-y-4 mb-6">
              <h4 class="text-lg font-medium text-gray-300">ข้อมูลพื้นฐาน</h4>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium mb-1 text-gray-300">ชื่อซอมบี้</label>
                  <input v-model="zombie.name" type="text" class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500" required />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1 text-gray-300">ลิงก์รูปภาพ</label>
                  <input v-model="zombie.imageUrl" type="url" class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500" required />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1 text-gray-300">เลเวลของซอมบี้</label>
                  <input v-model.number="zombie.level" type="number" min="1" max="1000" class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500" required />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1 text-gray-300">ประเภทซอมบี้</label>
                  <select
                    v-model="zombie.type"
                    class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    required
                  >
                    <option value="normal">ทั่วไป</option>
                    <option value="boss">บอส</option>
                  </select>
                </div>
              </div>
              <div>
                <label class="block text-sm font-medium mb-1 text-gray-300">คำอธิบาย</label>
                <textarea v-model="zombie.description" class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500" rows="2"></textarea>
              </div>
            </div>

            <div class="space-y-4 mb-6">
              <h4 class="text-lg font-medium text-gray-300">ค่าสถานะ</h4>
              <div class="grid grid-cols-2 sm:grid-cols-6 gap-4">
                <div>
                  <label class="block text-sm font-medium mb-1 text-gray-300">Stamina</label>
                  <input v-model.number="zombie.stats.stamina" type="number" min="0" class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1 text-gray-300">Str</label>
                  <input v-model.number="zombie.stats.str" type="number" min="0" class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1 text-gray-300">Agi</label>
                  <input v-model.number="zombie.stats.agi" type="number" min="0" class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1 text-gray-300">Int</label>
                  <input v-model.number="zombie.stats.int" type="number" min="0" class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1 text-gray-300">Defense</label>
                  <input v-model.number="zombie.stats.defense" type="number" min="0" class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1 text-gray-300">Luck</label>
                  <input v-model.number="zombie.stats.luck" type="number" min="0" class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                </div>
              </div>
              <p v-if="statDifference < 0" class="text-sm text-yellow-500 mt-2">คำแนะนำ: ขาด {{ Math.abs(statDifference) }} หน่วย (ค่าสถานะรวมควรเป็น {{ expectedStatTotal }})</p>
              <p v-else-if="statDifference > 0" class="text-sm text-red-500 mt-2">คำแนะนำ: เกิน {{ statDifference }} หน่วย (ค่าสถานะรวมควรเป็น {{ expectedStatTotal }})</p>
              <p v-else class="text-sm text-green-500 mt-2">คำแนะนำ: ค่าสถานะครบถ้วน (ค่าสถานะรวม {{ expectedStatTotal }})</p>
              <div class="flex flex-wrap gap-2 mt-3">
                <button type="button" @click="calculateStats('highHP')" class="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200">
                  ซอมบี้เลือดเยอะ
                </button>
                <button type="button" @click="calculateStats('highAttack')" class="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200">
                  ซอมบี้โจมตีแรง
                </button>
                <button type="button" @click="calculateStats('fast')" class="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200">
                  ซอมบี้วิ่งไว
                </button>
                <button type="button" @click="calculateStats('smart')" class="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200">
                  ซอมบี้ฉลาดมาก
                </button>
                <button type="button" @click="calculateStats('highDefense')" class="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200">
                  ซอมบี้พลังป้องกันสูง
                </button>
                <button type="button" @click="calculateStats('lucky')" class="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200">
                  ซอมบี้โชคดี
                </button>
              </div>
            </div>

            <div class="space-y-4 mb-6">
              <h4 class="text-lg font-medium text-gray-300">คุณสมบัติพิเศษและรางวัล</h4>
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div>
                  <label class="block text-sm font-medium mb-1 text-gray-300">โอกาสการติดเชื้อ (%)</label>
                  <input v-model.number="zombie.infectionChance" type="number" min="0" max="100" class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1 text-gray-300">EXP ที่ได้รับ</label>
                  <input v-model.number="zombie.expReward" type="number" min="0" class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1 text-gray-300">Silver ที่ได้รับ</label>
                  <input v-model.number="zombie.silverReward" type="number" min="0" class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                </div>
              </div>
            </div>

            <div class="flex justify-end gap-3">
              <button type="submit" class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200">
                บันทึกการแก้ไข
              </button>
              <button @click="deleteZombie" type="button" class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition duration-200">
                ลบซอมบี้
              </button>
              <button @click="cancelModal" type="button" class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition duration-200">
                ยกเลิก
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { projectFirestore } from '@/firebase/config';

export default {
  props: ['zombie'],
  setup(props, context) {
    const zombie = ref({
      ...props.zombie,
      stats: {
        stamina: props.zombie.stats?.stamina || 0,
        str: props.zombie.stats?.str || 0,
        agi: props.zombie.stats?.agi || 0,
        int: props.zombie.stats?.int || 0,
        defense: props.zombie.stats?.defense || 0,
        luck: props.zombie.stats?.luck || 0
      },
      type: props.zombie.type || 'normal', // Initialize type, default to 'normal'
      expReward: props.zombie.expReward || 10, // Default to 10 for level 1 normal zombie
      infectionChance: props.zombie.infectionChance || 10 // Default to 10% for normal zombie
    });

    // Function to update expReward and infectionChance based on level and type
    const updateRewards = () => {
      if (zombie.value.type === 'boss') {
        zombie.value.expReward = 100; // Boss: 100 EXP for all levels
        zombie.value.infectionChance = 50; // Boss: 50% infection chance
      } else {
        // Normal zombie: EXP = 5 + 5 * level
        zombie.value.expReward = 5 + zombie.value.level * 5;
        zombie.value.infectionChance = 10; // Normal: 10% infection chance
      }
    };

    // Watch for changes in level and type
    watch([() => zombie.value.level, () => zombie.value.type], () => {
      updateRewards();
    });

    // Calculate expected stat total based on level and type
    const expectedStatTotal = computed(() => {
      return zombie.value.type === 'boss' ? zombie.value.level * 4 : zombie.value.level * 3;
    });

    // Calculate actual stat total
    const actualStatTotal = computed(() => {
      const stats = zombie.value.stats;
      return (stats.stamina || 0) + (stats.str || 0) + (stats.agi || 0) + (stats.int || 0) + (stats.defense || 0) + (stats.luck || 0);
    });

    // Calculate difference between actual and expected stat totals
    const statDifference = computed(() => actualStatTotal.value - expectedStatTotal.value);

    const calculateStats = (type) => {
      const totalPoints = zombie.value.type === 'boss' ? zombie.value.level * 5 : zombie.value.level * 3; // Total stat points based on type
      const staminaPoints = Math.round(totalPoints * 0.4); // 40% for stamina
      const primaryPoints = Math.round(totalPoints * 0.3); // 30% for primary stat
      const secondaryPoints = Math.round(totalPoints * 0.15); // 15% for each secondary stat

      // Calculate used points and remainder to ensure exact total
      const usedPoints = staminaPoints + primaryPoints + secondaryPoints * 2;
      const remainder = totalPoints - usedPoints; // Positive or negative remainder

      let newStats = { stamina: staminaPoints, str: 0, agi: 0, int: 0, defense: 0, luck: 0 };

      switch (type) {
        case 'highHP':
          newStats.str = secondaryPoints; // 15%
          newStats.agi = secondaryPoints + remainder; // 15% + remainder
          newStats.int = 0;
          newStats.defense = 0;
          newStats.luck = 0;
          break;
        case 'highAttack':
          newStats.str = primaryPoints; // 30%
          newStats.agi = secondaryPoints; // 15%
          newStats.int = secondaryPoints + remainder; // 15% + remainder
          newStats.defense = 0;
          newStats.luck = 0;
          break;
        case 'fast':
          newStats.agi = primaryPoints; // 30%
          newStats.str = secondaryPoints; // 15%
          newStats.int = secondaryPoints + remainder; // 15% + remainder
          newStats.defense = 0;
          newStats.luck = 0;
          break;
        case 'smart':
          newStats.int = primaryPoints; // 30%
          newStats.str = secondaryPoints; // 15%
          newStats.agi = secondaryPoints + remainder; // 15% + remainder
          newStats.defense = 0;
          newStats.luck = 0;
          break;
        case 'highDefense':
          newStats.defense = primaryPoints; // 30%
          newStats.str = secondaryPoints; // 15%
          newStats.agi = secondaryPoints + remainder; // 15% + remainder
          newStats.int = 0;
          newStats.luck = 0;
          break;
        case 'lucky':
          newStats.luck = primaryPoints; // 30%
          newStats.str = secondaryPoints; // 15%
          newStats.agi = secondaryPoints + remainder; // 15% + remainder
          newStats.int = 0;
          newStats.defense = 0;
          break;
      }

      // Ensure no negative stats
      Object.keys(newStats).forEach((key) => {
        if (newStats[key] < 0) newStats[key] = 0;
      });

      zombie.value.stats = newStats;
    };

    const cancelModal = () => context.emit('cancelModal');

    const updateZombie = async () => {
      try {
        const updatedData = {
          name: zombie.value.name,
          imageUrl: zombie.value.imageUrl,
          level: zombie.value.level,
          type: zombie.value.type,
          description: zombie.value.description,
          stats: zombie.value.stats,
          infectionChance: zombie.value.infectionChance,
          expReward: zombie.value.expReward || 0,
          silverReward: zombie.value.silverReward || 0,
          createdAt: zombie.value.createdAt,
          damageTaken: zombie.value.damageTaken || 0,
        };

        // Delete old document
        await projectFirestore.collection('gameZombies').doc(zombie.value.id).delete();

        // Create new document with zombie name as ID
        await projectFirestore.collection('gameZombies').doc(zombie.value.name).set(updatedData);

        cancelModal();
      } catch (error) {
        console.error('Error updating zombie:', error);
      }
    };

    const deleteZombie = async () => {
      if (confirm('คุณแน่ใจหรือไม่ว่าต้องการลบซอมบี้นี้? การกระทำนี้ไม่สามารถย้อนกลับได้')) {
        try {
          await projectFirestore.collection('gameZombies').doc(zombie.value.id).delete();
          context.emit('zombieDeleted');
          cancelModal();
        } catch (error) {
          console.error('Error deleting zombie:', error);
        }
      }
    };

    const handleKeydown = (event) => {
      if (event.key === 'Escape') {
        cancelModal();
      }
    };

    onMounted(() => {
      window.addEventListener('keydown', handleKeydown);
      updateRewards(); // Initialize rewards on mount
    });

    onUnmounted(() => {
      window.removeEventListener('keydown', handleKeydown);
    });

    return { zombie, expectedStatTotal, actualStatTotal, statDifference, calculateStats, cancelModal, updateZombie, deleteZombie };
  },
};
</script>